'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowLeft } from '@subframe/core';
import { Button, LogoArbitralis } from '@/shared/components/ui';
interface BackHeaderProps {
  onVoltar: () => void;
}
export const BackHeader = t0 => {
  const $ = _c(6);
  const {
    onVoltar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherArrowLeft />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onVoltar) {
    t2 = <Button variant="neutral-tertiary" size="small" icon={t1} onClick={onVoltar}>Voltar</Button>;
    $[1] = onVoltar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogoArbitralis className="[&_img]:h-6 [&_img]:w-auto" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="flex items-center justify-between border-b border-solid border-neutral-200 px-6 py-6 md:px-20">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};